"use client";

import { useEffect } from "react";

interface RecordingTooShortToastProps {
  isGuest: boolean;
  onDismiss: () => void;
}

export default function RecordingTooShortToast({
  isGuest,
  onDismiss,
}: RecordingTooShortToastProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 5000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      className="fixed bottom-6 left-1/2 animate-slide-up z-50 w-[calc(100%-2rem)] max-w-[420px]"
      style={{ transform: "translateX(-50%)" }}
      role="alert"
    >
      <div className="bg-white rounded-lg shadow-lg border border-border px-5 py-4 border-l-4 border-l-warning">
        <div className="flex items-start gap-3">
          <svg
            className="w-5 h-5 text-warning shrink-0 mt-0.5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <div>
            <p className="text-sm font-semibold text-text">
              回答が短すぎました
            </p>
            <p className="text-xs text-subtext mt-1 leading-relaxed">
              面接官に伝わる回答には、最低10秒は必要です。もう一度、じっくり話してみましょう！
            </p>
            {isGuest && (
              <p className="text-xs text-subtext mt-1 font-medium">
                練習回数は消費されていません
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
